
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import Cookies from 'universal-cookie';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDaBfKRYAPuyLwNWMXO5dRP9h96h1CBx4E",
    authDomain: "esfahan-pack-hr.firebaseapp.com",
    projectId: "esfahan-pack-hr",
    storageBucket: "esfahan-pack-hr.appspot.com",
    messagingSenderId: "709412129031",
    appId: "1:709412129031:web:8577071f40af365f01dda2",
    measurementId: "G-M26CBKNXFM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);
const messaging = getMessaging(app);

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/firebase-messaging-sw.js').then((registration) => {
     
    }).catch((err) => {
        console.error('Service Worker registration failed:', err);
    });
}

export const requestPermission = () => {



    Notification.requestPermission().then(per => {
        if (per === 'granted') {
            return getToken(messaging, {
                vapidKey: 'BP0HoQgu03hpCGsEvgDUm-aElJaghzwyg_2XSjwc7wsBxz-Z4D0lcAAFR99YcMISCPAitj8VsCiMtQPPzumYGmI'
            })
                .then(curentToken => {
                    if (curentToken) {
                        console.log('client token ' + curentToken)
                        const cookies = new Cookies();
                        cookies.remove('client');
                        cookies.set('client',curentToken)
                    } else {
                        console.log('failed to gene tok')
                    }
                })
                .catch(err => {
                    console.log('ERRROOORRR' + err)
                });
        }
        else {
            console.log('no noti permis')
        }
    })
}

requestPermission();

export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });